export interface IsExternalLinkOptions {
  internalHrefPrefixes?: string[];
}

export const isInternalLink = (href: string | undefined) => {
  if (!href) return true;
  return href.startsWith('/');
};

/** Paths served as static plain-text files (not SPA pages). */
const NATIVE_NAVIGATION_PATHS = new Set(['/llms.txt', '/ai.txt']);

export const isSpecialLink = (href: string | undefined) => {
  if (!href) return false;
  return (
    href.startsWith('#') ||
    href.startsWith('mailto:') ||
    href.startsWith('tel:') ||
    NATIVE_NAVIGATION_PATHS.has(href)
  );
};

export const isExternalLink = (
  href: string | undefined,
  { internalHrefPrefixes = [] }: IsExternalLinkOptions = {}
) => {
  if (!href || isInternalLink(href) || isSpecialLink(href)) return false;

  return !internalHrefPrefixes.some((prefix) => href.startsWith(prefix));
};
